import _ from 'underscore';

/**
 * value converter for native field
 * @param {String} name - name of field
 * @param {Object} schemaField - viewmodel field property
 * @param {Object} viewModel - current backbone model
 */
class FieldConverter {
  constructor(name, schemaField, viewModel) {
    this.name = name;
    this.schemaField = schemaField;
    this.viewModel = viewModel;
  }

  parse(field) {
    this.viewModel.set(this.name, this.schemaField.conversion.fromModel(field));
  }

  toJSON() {
    return this.schemaField.conversion.toModel(this.viewModel.get(this.name));
  }
}

/**
 * value converter for nested entity field
 * @param {String} name - name of field
 * @param {Object} viewModel - current backbone model
 */
class NestedConverter {
  constructor(name, viewModel) {
    this.name = name;
    this.viewModel = viewModel;
  }

  parse(field) {
    this.viewModel.get(this.name).parse(field);
  }

  toJSON() {
    return this.viewModel.get(this.name).toJSON();
  }
}

/**
 * value converter for backbone model. Converter is loaded from viewmodel-schema field
 * @param {Object} vmSchema - viewmodel-schema that contains default values
 * @param {Object} viewModel - current backbone model
 */
export class Converter {
  constructor(vmSchema, viewModel) {
    this.fieldConverters = _.mapObject(vmSchema, (schemaField, name) =>
      (schemaField.prop.type === 'object' ?
        new NestedConverter(name, viewModel) :
        new FieldConverter(name, schemaField, viewModel)));
  }

  /**
  * parse values from raw model. Overrides default backbone implementation
  * @param {Object} model - raw model that contains field values
  * @returns {undefined}
  */
  parse(model) {
    _.each(this.fieldConverters, fc => fc.parse(_.result(model, fc.name)));
  }

  /**
  * convert backbone model to raw model (plain object). Overrides default backbone implementation
  * @returns {Object} - returns raw model
  */
  toJSON() {
    return _.mapObject(this.fieldConverters, fc => fc.toJSON());
  }
}
